import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, CalendarDays, LogOut, Sparkles, Receipt, Settings as SettingsIcon } from "lucide-react";
import { adminApi, isAdmin } from "./api";

const NAV = [
  { to: "/admin",              label: "Overview",     icon: LayoutDashboard, end: true },
  { to: "/admin/transactions", label: "Transactions", icon: Receipt },
  { to: "/admin/clients",      label: "Clients",      icon: Users },
  { to: "/admin/availability", label: "Availability", icon: CalendarDays },
  { to: "/admin/settings",     label: "Settings",     icon: SettingsIcon },
];

export default function AdminLayout() {
  const nav = useNavigate();

  useEffect(() => {
    if (!isAdmin()) {
      nav("/admin/login", { replace: true });
      return;
    }
    adminApi.get("/me").catch(() => {}); // triggers 401 redirect if expired
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("kl_admin_token");
    nav("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] text-slate-900 flex" data-testid="admin-shell">
      <aside className="w-64 shrink-0 bg-white border-r border-slate-200 flex flex-col">
        <div className="px-6 py-6 border-b border-slate-100">
          <Link to="/" className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-amber-500 shadow-[0_0_10px_#F59E0B]" />
            <span className="font-serif text-xl text-slate-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Kama <span className="italic text-amber-600">Loka</span> Journeys
            </span>
          </Link>
          <p className="mt-2 text-[10px] uppercase tracking-[0.22em] text-slate-400">admin</p>
        </div>
        <nav className="flex-1 px-3 py-6 space-y-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors ${
                  isActive
                    ? "bg-slate-900 text-white"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-100">
          <button
            data-testid="admin-logout"
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-slate-600 hover:bg-slate-100"
          >
            <LogOut className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
